import { DefectSummaryDataItem } from "../../types/DefectSummaryDataItem";
import { FilterMatchMode } from "primereact/api";
import { useAppDispatch } from "../../hooks/storeHooks";
import { setActiveTab } from "../../store/slices/defectSlice";
import { resetTableFilters } from "../../store/thunks/filtersThunks";
import { getSummaryTableLinkConfig } from "../../utils/DefectsSummaryTableDataHelper";

type SharedDefectSummaryTotalDefectsLinkProps = {
    rowData: DefectSummaryDataItem
} 

export const SharedDefectSummaryTotalDefectsLink = (props: SharedDefectSummaryTotalDefectsLinkProps) => {
    const { rowData } = props;
    const dispatch = useAppDispatch();

    const { tableKey, defaultConfig, nameField, statusField } = getSummaryTableLinkConfig(true);

    const navigateToDefectsTab = () => {
        dispatch(resetTableFilters(tableKey, {
            ...defaultConfig,
            [nameField]: { value: rowData.vesselName, matchMode: FilterMatchMode.CONTAINS },
            [statusField]: { value: [], matchMode: FilterMatchMode.IN },
        }));
        dispatch(setActiveTab(1));
    }

    return (
        <button className="font-semibold underline cursor-pointer read-more-btn total-defect-btn" onClick={navigateToDefectsTab}>
            {rowData.totalDefects}
        </button>
    );
};
